import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'done'>('idle');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    setStatus('loading');
    try {
      const res = await fetch('https://auth.ts1cloud.com/auth/password-reset/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error((data as any).error || 'Request failed');
      }
      setStatus('done');
    } catch (err: any) {
      setError(err.message || 'Something went wrong');
      setStatus('idle');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-pattern py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="bg-app-panel/80 backdrop-blur-sm p-8 rounded-lg shadow-lg">
          <div className="flex justify-center">
            <Logo className="h-12 w-auto mb-6 text-indigo-600" />
          </div>
          <h2 className="text-center text-2xl font-bold text-gray-900">Forgot your password?</h2>
          {status === 'done' ? (
            <div className="mt-6 text-center space-y-4">
              <p className="text-gray-700">If that account exists, you'll receive a reset link shortly.</p>
              <p className="text-sm text-gray-500">Check your email and follow the link. It expires in 1 hour.</p>
              <Link to="/login" className="block text-indigo-600 hover:text-indigo-500 text-sm">
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <p className="mt-2 text-center text-sm text-gray-600">
                Enter your email address and we'll send you a reset link along with your company name.
              </p>
              {error && (
                <div className="mt-4 rounded-md bg-red-50 p-3 text-sm text-red-700">{error}</div>
              )}
              <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
                <input
                  type="email"
                  required
                  placeholder="Email address"
                  autoComplete="email"
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                >
                  {status === 'loading' ? 'Sending...' : 'Send reset link'}
                </button>
              </form>
              <div className="mt-4 text-center">
                <Link to="/login" className="text-sm text-indigo-600 hover:text-indigo-500">
                  Back to sign in
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
